import { useMemo } from "react";

export interface AsanaSourceSettingsText {
  workspaceLabelText: string;
  workspacePlaceholderText: string;
  workspaceHintText: string;
  projectsLabelText: string;
  projectsPlaceholderText: string;
  projectsHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useAsanaSourceSettingsText = (
  t: (key: string) => string,
): AsanaSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.asana.${key}`);

    return {
      workspaceLabelText: tKey("workspaceLabel"),
      workspacePlaceholderText: tKey("workspacePlaceholder"),
      workspaceHintText: tKey("workspaceHint"),
      projectsLabelText: tKey("projectsLabel"),
      projectsPlaceholderText: tKey("projectsPlaceholder"),
      projectsHintText: tKey("projectsHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
